import { useDialog } from 'ogp/providers/dialog-provider';
import { useAlert } from 'shared/components/alerts';
import { useSiteDetection } from 'shared/hooks';
import { useBlockPayment } from './use-block-payment';
import { useResendPayment } from './use-resend-payment';
import { useUnblockPayment } from './use-unblock-payment';
import { useForcePayPayment } from './use-force-pay-payment';

export const useGetPaymentActionHandlers = () => {
  const blockPaymentMutation = useBlockPayment();
  const unblockPaymentMutation = useUnblockPayment();
  const resendPaymentMutation = useResendPayment();
  const forcePayPaymentMutation = useForcePayPayment();
  const { openDialog, closeDialog } = useDialog();
  const { alertSuccess, alertError } = useAlert();
  const { site } = useSiteDetection();

  const handleBlockPayment = (paymentId: string) => {
    blockPaymentMutation.mutate(
      { site, paymentId },
      {
        onSuccess: () => alertSuccess('Betaling succesvol geblokkeerd'),
        onError: alertError,
      }
    );
  };

  const handleUnblockPayment = (paymentId: string) => {
    unblockPaymentMutation.mutate(
      { site, paymentId },
      {
        onSuccess: () => alertSuccess('Betaling succesvol gedeblokkeerd'),
        onError: alertError,
      }
    );
  };
  const handleResendPayment = (paymentId: string) => {
    openDialog(
      {
        title: 'Let op!',
        content:
          'Door deze betaling (opnieuw) uit te voeren, wordt de dagelijkse fraude-limiet mogelijk overschreden. Weet je zeker dat je deze betaling wilt uitvoeren?',
      },
      () => {
        closeDialog();
        resendPaymentMutation.mutate(
          { site, paymentId },
          {
            onSuccess: () => alertSuccess('Betaling succesvol opnieuw verzonden'),
            onError: alertError,
          }
        );
      }
    );
  };

  const handleForcePayPayment = (paymentId: string) => {
    openDialog(
      {
        title: 'Let op!',
        content: 'Weet je zeker dat je deze betaling wilt forceren?',
      },
      () => {
        closeDialog();
        forcePayPaymentMutation.mutate(
          { site, paymentId },
          {
            onSuccess: () => alertSuccess('Betaling succesvol verzonden'),
            onError: alertError,
          }
        );
      }
    );
  };

  return {
    handleBlockPayment,
    handleUnblockPayment,
    handleResendPayment,
    handleForcePayPayment,
  };
};
